export const SlideOverCustomization = {
  bodyClasses: "bg-white w-full ",
  innerPadding: "px-0 py-20",
  containerClasses: "md:pl-6 pl-0",
  buttonClasses: "border-none focus:outline-none text-dark-text bg-body h-8 w-8 rounded-full p-1",
};